var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 9,
    viewBox: "0 0 19 9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#115E67",
    d: "M0 4.494c0 .496.466.898 1.04.898h14.371L13.02 7.448c-.408.362-.399.941.02 1.293.42.352 1.09.344 1.498-.018l4.161-3.592c.095-.085.169-.186.219-.296.11-.218.11-.465 0-.683-.05-.11-.124-.21-.219-.296L14.538.264c-.409-.352-1.07-.352-1.478 0-.408.352-.408.923 0 1.275l2.351 2.057H1.041C.465 3.596 0 3.998 0 4.494z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.0682306834c5696f1cf2a688c82a29a6.svg";
export { ForwardRef as ReactComponent };